/*
 *  Copyright (C) 2025 - SimpliCity Digital Inc - All Rights Reserved
 */

import Joi from "joi";
import { Logger } from "cms/utils/log/logger";

export const documentValidator = Joi.object({
    guid: Joi.string().guid().optional(),
    // organization: Joi.string().guid().option(),
    title: Joi.string().required(),
    description: Joi.string().optional().allow(null,""),
    link_text: Joi.string().optional().allow(null,""),
    url: Joi.string().required(),
    doc_id: Joi.string().required().allow(null,""),
    type: Joi.string().required().allow(null,""),
    external_id: Joi.string().optional().allow(null,""),
    classification: Joi.string().optional().allow(null,""),
    sub_classification: Joi.string().optional().allow(null,""),
    language: Joi.string().required().default("en"),
    owner: Joi.string().optional().allow(null,""),
    author: Joi.string().optional().allow(null,""),
    audience: Joi.string().optional().allow(null,""),  // ie. developers, council, general
    retention_months: Joi.number().optional().allow(null),  // boolean: internal/external
    public: Joi.boolean().optional().allow(null),  // boolean: internal/public
    archived: Joi.boolean().optional().allow(null),  // boolean: active/archived
    isReplica: Joi.boolean().optional().allow(null),  // boolean: active/archived
    file_name: Joi.string().optional(),
    file_ext: Joi.string().optional(),
    file_type: Joi.string().optional(),
    file_size: Joi.number().integer().optional(),
    storage_account: Joi.string().optional(),
    storage_container: Joi.string().optional(),
    storage_filepath: Joi.string().optional(),
    storage_url: Joi.string().optional(),
});


export const setDocumentDefaults = (document) => {
    return {
        ...document,
        title: document?.title ?? "",
        description: document?.description ?? "",
        link_text: document?.link_text ?? "",
        doc_id: document?.doc_id ?? null,
        type: document?.type ?? null,
        external_id: document?.external_id ?? null,
        classification: document?.classification ?? null,
        sub_classification: document?.sub_classification ?? null,
        language: document?.language ?? "en",
        owner: document?.owner ?? null,
        author: document?.author ?? null,
        audience: document?.audience ?? null,
        retention_months: document?.retention_months ?? 84,
        public: document?.public ?? false,
        archived: document?.archived ?? false,
    };
};

export const validateDocument = async (document) => {
    // const result = Joi.validate(document, documentValidator)
    const result = documentValidator.validate(document);
    
    if (!result.error) {
        return result?.value;
    } else {
        Logger.warn(`${result?.error?.details?.message}`, result.error);
        Logger.warn("original", result?.error?._original);
        return false;
    }
};
